import {initDetailByAPI} from '@web/actions/detail'
import makeSlice from '@web/slices/aitems/sliceMaker'

const aitemsSlice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initDetailByAPI.fulfilled, (state, {payload: {data}}) => {
            state.products = data.productOrders.map((product) => {
                return {
                    ecNvMid: `${product?.ecNvMid ?? ''}`,
                }
            })
        })
    },
})

export default aitemsSlice.reducer
